export enum Role {
  admin = 'admin',
  dashboard = 'dashboard'
}
